<template>
  <button
    type="button"
    class="mobile-filters-toggle d-lg-none"
    :class="{ 'is-open': isOpen }"
    @click="$emit('click')"
  >
    <i class="fas fa-sliders-h" />
    <span>{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'MobileFiltersToggle',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-filters-toggle {
  align-items: center;
  background: #fff;
  border: 0.1rem solid #e4e4e4;
  border-radius: 0.25rem;
  color: #7a7d82;
  display: inline-flex;
  gap: 0.7rem;
  justify-content: center;
  height: 44px;
  min-height: 44px;
  padding: 0 1.6rem;
  text-transform: uppercase;
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1;
}

@media (max-width: 575px) {
  .mobile-filters-toggle {
    gap: 0.5rem;
    padding: 0 1rem;
    font-size: 1.3rem;
    letter-spacing: 0.03em;
  }

  .mobile-filters-toggle i {
    font-size: 1.3rem;
  }
}

.mobile-filters-toggle.is-open {
  border-color: #1e84bc;
  color: #1e84bc;
}

.mobile-filters-toggle i {
  font-size: 1.3rem;
}
</style>

<style lang="scss">
@media (max-width: 767px) {
  .toolbox.row {
    row-gap: 1rem;
  }

  .mobile-toolbox-controls {
    align-items: stretch;
    display: flex;
    flex-wrap: nowrap;
    gap: 0.6rem;
  }

  .mobile-toolbox-controls > .toolbox-item {
    align-items: stretch;
    display: flex;
    margin-right: 0 !important;
    min-width: 0;
  }

  .mobile-toolbox-controls > .toolbox-item:nth-child(1) {
    flex: 1.35 1 0;
  }

  .mobile-toolbox-controls > .toolbox-item:nth-child(2) {
    flex: 0.65 1 0;
  }

  .mobile-toolbox-controls > .toolbox-item:nth-child(3) {
    flex: 0.9 1 0;
  }

  .mobile-toolbox-controls > .toolbox-item .select-custom,
  .mobile-toolbox-controls > .toolbox-item .select-custom .form-control,
  .mobile-toolbox-controls > .toolbox-item .mobile-filters-toggle {
    width: 100%;
  }

  .mobile-toolbox-controls > .toolbox-item .select-custom {
    display: flex;
  }

  .mobile-toolbox-controls > .toolbox-item .select-custom:after {
    right: 0.9rem;
  }

  .mobile-toolbox-controls > .toolbox-item .form-control {
    height: 44px;
    max-width: none;
    min-height: 44px;
    padding-left: 0.9rem;
    padding-right: 2.4rem;
    font-size: 1.3rem;
    text-overflow: ellipsis;
  }
}
</style>
